export const articles = [
  {
    id: 'article-1',
    slug: 'dingzhen-chugui-baoguang',
    title: '某知名男星深夜密会神秘女子，酒店共度8小时，出轨实锤曝光',
    excerpt: '据知情人士透露，该男星与妻子结婚仅两年，此次被拍到与一名年轻女子深夜进入某五星级酒店，直到次日清晨才离开。',
    content: `据多方消息源独家爆料，娱乐圈某知名男星近日被拍到深夜密会一名神秘女子。据目击者称，当晚11点左右，该男星驾驶豪车抵达位于北京朝阳区的某五星级酒店，约20分钟后，一名身穿黑色连衣裙的年轻女性也抵达酒店并直接乘坐电梯前往客房楼层。

据酒店内部人士透露，两人在房间内共度了约8小时，直至次日清晨7点才先后离开。更有媒体爆料称，该男星与妻子结婚仅两年，此前曾多次在公开场合秀恩爱，此次出轨事件曝光后引发网友热议。

目前该男星工作室尚未对此事作出回应，但其社交媒体评论区已被网友攻陷，大量粉丝表示"塌房了"。此事也引发了关于娱乐圈明星私德的广泛讨论。`,
    cardImage: 'https://readdy.ai/api/search-image?query=Dramatic%20nighttime%20scene%20outside%20a%20luxury%20hotel%20in%20Beijing%20with%20paparazzi%20atmosphere%20dim%20lighting%20a%20luxury%20car%20parked%20near%20the%20entrance%20mysterious%20silhouettes%20cinematic%20moody%20tones%20editorial%20photography%20style%20with%20soft%20shadows%20and%20rich%20contrast&width=600&height=375&seq=card-dingzhen-chugui&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Dramatic%20nighttime%20scene%20outside%20a%20luxury%20hotel%20in%20Beijing%20with%20paparazzi%20atmosphere%20dim%20lighting%20a%20luxury%20car%20parked%20near%20the%20entrance%20mysterious%20silhouettes%20cinematic%20moody%20tones%20editorial%20photography%20style%20with%20soft%20shadows%20and%20rich%20contrast&width=1200&height=675&seq=detail-dingzhen-chugui&orientation=landscape',
    category: 'mingxing-bagua',
    author: '吃瓜前线记者',
    publishDate: '2026-07-06',
    readCount: 285600,
    commentCount: 4832,
    featured: true,
    tags: ['出轨', '男星', '酒店密会', '塌房'],
  },
  {
    id: 'article-2',
    slug: 'wanghong-zhibo-fanche',
    title: '千万粉丝网红直播带货翻车，假货被当场拆穿，场面一度失控',
    excerpt: '该网红在直播间声称销售的是"正品大牌"，却被消费者当场拿出专柜鉴定报告打脸，直播间评论区瞬间炸锅。',
    content: `拥有超过1200万粉丝的知名带货网红"小美姐姐"在昨晚的直播中遭遇了职业生涯最大翻车现场。当时她正在推销一款声称是"某国际大牌正品"的护肤品，售价仅需专柜的三分之一。

然而直播进行到一半时，一名消费者在评论区晒出了专柜鉴定报告，明确指出该产品为高仿假货。现场气氛瞬间凝固，主播面色尴尬，随后试图辩解称"供应商提供的货源我们都会严格审核"。

但消费者并不买账，弹幕瞬间被"假货""退钱""封号"等词汇刷屏。更尴尬的是，品牌官方旗舰店也在微博发声，表示从未授权该主播销售其产品。截至发稿，该网红已删除相关直播回放，但相关截图已在各大社交平台疯传。`,
    cardImage: 'https://readdy.ai/api/search-image?query=Chinese%20influencer%20livestreaming%20in%20a%20bright%20studio%20filled%20with%20products%20shocked%20expression%20on%20face%20dramatic%20moment%20warm%20lighting%20modern%20livestream%20setup%20editorial%20photography%20high%20detail%20cinematic%20mood&width=600&height=375&seq=card-zhibo-fanche&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Chinese%20influencer%20livestreaming%20in%20a%20bright%20studio%20filled%20with%20products%20shocked%20expression%20on%20face%20dramatic%20moment%20warm%20lighting%20modern%20livestream%20setup%20editorial%20photography%20high%20detail%20cinematic%20mood&width=1200&height=675&seq=detail-zhibo-fanche&orientation=landscape',
    category: 'wanghong-heiliao',
    author: '爆料小分队',
    publishDate: '2026-07-06',
    readCount: 198300,
    commentCount: 3215,
    featured: true,
    tags: ['直播翻车', '假货', '网红', '带货'],
  },
  {
    id: 'article-3',
    slug: 'nvyouxing-zhengrong-fengbo',
    title: '当红女星整容前后对比照流出，面部变化惊人，粉丝直呼认不出',
    excerpt: '有网友扒出该女星出道前的素颜照与近期活动照进行对比，鼻子、下巴、眼睛等部位变化明显，引发整容质疑。',
    content: `近日，一组当红女星的整容前后对比照在网络上引发热议。照片显示，该女星出道初期的面容与现在判若两人——鼻梁明显变高变挺，下巴从圆润变得尖削，双眼皮也更加深邃明显。

整容医生@Dr.Li在社交媒体上分析称："从专业角度来看，该女星很可能做过鼻综合、下颌角缩小、开眼角等多个项目，这些手术叠加起来对面部轮廓的改变是巨大的。"

但也有粉丝力挺偶像，称"女大十八变""化妆技术好了而已"。该女星本人目前尚未对此事作出回应。不过有业内人士透露，娱乐圈整容早已是公开的秘密，只是程度不同而已。`,
    cardImage: 'https://readdy.ai/api/search-image?query=Split%20comparison%20style%20image%20showing%20dramatic%20before%20and%20after%20beauty%20transformation%20elegant%20woman%20in%20soft%20lighting%20beauty%20clinic%20aesthetic%20editorial%20photography%20minimal%20background%20with%20warm%20tones%20sophisticated%20composition&width=600&height=375&seq=card-zhengrong&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Split%20comparison%20style%20image%20showing%20dramatic%20before%20and%20after%20beauty%20transformation%20elegant%20woman%20in%20soft%20lighting%20beauty%20clinic%20aesthetic%20editorial%20photography%20minimal%20background%20with%20warm%20tones%20sophisticated%20composition&width=1200&height=675&seq=detail-zhengrong&orientation=landscape',
    category: 'mingxing-bagua',
    author: '娱乐深扒君',
    publishDate: '2026-07-05',
    readCount: 352100,
    commentCount: 5678,
    featured: true,
    tags: ['整容', '女星', '对比照', '娱乐圈'],
  },
  {
    id: 'article-4',
    slug: 'douyin-wanghong-heilishi',
    title: '抖音顶流网红黑历史被扒：曾参与网络诈骗，涉案金额高达数百万',
    excerpt: '有网友发现该网红早年曾因参与电信诈骗被警方抓获，相关裁判文书已在网上公开，引发轩然大波。',
    content: `一位拥有超过2000万粉丝的抖音顶流网红近日被网友扒出惊人黑历史。据悉，该网红在成名前曾参与一起电信诈骗案件，涉案金额高达数百万元，相关裁判文书在中国裁判文书网上均可查到。

消息传出后，该网红的抖音账号评论区瞬间沦陷，大量粉丝表示"太失望了""怪不得总觉得他怪怪的"。更有网友扒出该网红早年社交动态中的蛛丝马迹，发现其生活方式在2019年前后发生了巨大变化，疑与诈骗所得有关。

目前抖音平台尚未对该网红账号采取任何措施，但有消息称平台方正在内部评估此事。法律界人士表示，如果裁判文书属实，该网红可能面临平台封号以及商业合作解约等后果。`,
    cardImage: 'https://readdy.ai/api/search-image?query=Dark%20moody%20dramatic%20scene%20with%20smartphone%20screen%20displaying%20sensational%20news%20Chinese%20social%20media%20interface%20dim%20lighting%20atmosphere%20of%20revelation%20and%20mystery%20editorial%20photography%20style%20high%20contrast%20cinematic%20shadows&width=600&height=375&seq=card-douyin-heilishi&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Dark%20moody%20dramatic%20scene%20with%20smartphone%20screen%20displaying%20sensational%20news%20Chinese%20social%20media%20interface%20dim%20lighting%20atmosphere%20of%20revelation%20and%20mystery%20editorial%20photography%20style%20high%20contrast%20cinematic%20shadows&width=1200&height=675&seq=detail-douyin-heilishi&orientation=landscape',
    category: 'wanghong-heiliao',
    author: '吃瓜前线记者',
    publishDate: '2026-07-05',
    readCount: 421500,
    commentCount: 8921,
    featured: false,
    tags: ['抖音', '网红', '诈骗', '黑历史'],
  },
  {
    id: 'article-5',
    slug: 'yulequan-qiang-juese',
    title: '娱乐圈抢角大战内幕曝光：某顶流靠资本运作抢走新人重要角色',
    excerpt: '圈内知情人士爆料，某S+级项目原定新人演员出演的主角，被顶流明星通过资本运作硬生生抢走。',
    content: `娱乐圈的资源争夺从来都是暗流涌动。近日有圈内知情人士向本网爆料，某知名影视公司投资的一部S+级古装剧，原本已经确定由一位新人演员出演男主角，导演对其试镜表现赞不绝口。

然而就在开拍前两周，一位顶流明星突然空降剧组，直接取代了新人演员的位置。据爆料人透露，该顶流明星背后的经纪公司与投资方有着千丝万缕的关系，通过追加投资的方式强行要求换角。

此事在圈内引发不小震动，多位导演和制片人在私下场合表达了对这种现象的担忧。"现在好的项目本来就少，新人根本没有出头之日，整个行业被几个顶流和资本把持着，这样下去对行业生态非常不利。"一位不愿具名的导演如此表示。`,
    cardImage: 'https://readdy.ai/api/search-image?query=Dramatic%20backstage%20scene%20of%20Chinese%20film%20production%20set%20with%20warm%20spotlight%20dramatic%20shadows%20empty%20director%20chair%20contrasting%20light%20and%20dark%20areas%20cinematic%20atmosphere%20behind%20the%20scenes%20editorial%20photography&width=600&height=375&seq=card-qiang-juese&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Dramatic%20backstage%20scene%20of%20Chinese%20film%20production%20set%20with%20warm%20spotlight%20dramatic%20shadows%20empty%20director%20chair%20contrasting%20light%20and%20dark%20areas%20cinematic%20atmosphere%20behind%20the%20scenes%20editorial%20photography&width=1200&height=675&seq=detail-qiang-juese&orientation=landscape',
    category: 'yule-shendu',
    author: '娱乐深扒君',
    publishDate: '2026-07-04',
    readCount: 187200,
    commentCount: 2456,
    featured: false,
    tags: ['资本运作', '抢角', '顶流', '娱乐圈内幕'],
  },
  {
    id: 'article-6',
    slug: 'kuaishou-zhubo-bei-ju',
    title: '快手男主播酒后直播失言，发表不当言论遭全网封杀',
    excerpt: '该主播凌晨酒后开播，言语间发表多条不当言论，被网友录屏举报，目前账号已被平台永久封禁。',
    content: `快手平台一位拥有500万粉丝的男主播在凌晨酒后直播时，因发表多条不当言论引发众怒。直播中，该主播言语粗俗，不仅辱骂观众，还对近期社会热点事件发表了极为不当的评论。

直播间观众迅速录屏并在各大平台传播，话题迅速登上微博热搜。平台方反应迅速，在直播进行约30分钟后强制中断了直播，随后发布公告称"该主播严重违反平台社区规范"，对其账号进行永久封禁处理。

业内人士分析认为，直播行业的野蛮生长时代正在过去，平台对主播的言行管控越来越严格，任何触碰红线的行为都会面临严厉处罚。这起事件也给其他主播敲响了警钟。`,
    cardImage: 'https://readdy.ai/api/search-image?query=Dark%20room%20late%20night%20scene%20with%20computer%20monitor%20showing%20banned%20account%20notice%20on%20Chinese%20streaming%20platform%20blue%20screen%20glow%20moody%20atmosphere%20dramatic%20lighting%20editorial%20photography%20with%20cinematic%20shadows&width=600&height=375&seq=card-zhubo-beiju&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Dark%20room%20late%20night%20scene%20with%20computer%20monitor%20showing%20banned%20account%20notice%20on%20Chinese%20streaming%20platform%20blue%20screen%20glow%20moody%20atmosphere%20dramatic%20lighting%20editorial%20photography%20with%20cinematic%20shadows&width=1200&height=675&seq=detail-zhubo-beiju&orientation=landscape',
    category: 'shehui-redian',
    author: '爆料小分队',
    publishDate: '2026-07-04',
    readCount: 234800,
    commentCount: 4125,
    featured: false,
    tags: ['快手', '主播', '封杀', '不当言论'],
  },
  {
    id: 'article-7',
    slug: 'mingxing-shuida-paizhao',
    title: '狗仔队拍到知名女艺人深夜与已婚富商密会，街头拥抱画面曝光',
    excerpt: '知名狗仔团队"娱乐圈揭底"拍到某女艺人与已婚富商深夜约会，两人在街头亲密拥抱的画面已被曝光。',
    content: `知名狗仔团队"娱乐圈揭底"再次出手，这次拍到了某知名女艺人与一位已婚富商的深夜密会画面。据狗仔队发布的视频显示，两人在某高档餐厅用餐后，在街头亲密拥抱，随后一同乘车离开。

据悉，这位富商是某上市公司高管，已婚并育有两个孩子。视频曝光后，该女艺人的社交媒体账号设置了评论限制，而其工作室则发布声明称"两人只是普通朋友关系，不存在任何越界行为"。

但网友对此并不买账，有网友扒出该女艺人与该富商此前多次同框的照片，"普通朋友会在深夜街头拥抱？骗谁呢？"更有网友指出，该富商的妻子在社交媒体上发布了一条意味深长的动态："有些真相，不需要解释。"`,
    cardImage: 'https://readdy.ai/api/search-image?query=Nighttime%20urban%20street%20scene%20in%20Chinese%20city%20blurry%20paparazzi%20style%20shot%20of%20two%20figures%20near%20luxury%20car%20warm%20street%20light%20atmosphere%20dramatic%20tension%20editorial%20tabloid%20photography%20moody%20cinematic%20tones&width=600&height=375&seq=card-shuida-paizhao&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Nighttime%20urban%20street%20scene%20in%20Chinese%20city%20blurry%20paparazzi%20style%20shot%20of%20two%20figures%20near%20luxury%20car%20warm%20street%20light%20atmosphere%20dramatic%20tension%20editorial%20tabloid%20photography%20moody%20cinematic%20tones&width=1200&height=675&seq=detail-shuida-paizhao&orientation=landscape',
    category: 'mingxing-bagua',
    author: '吃瓜前线记者',
    publishDate: '2026-07-03',
    readCount: 389400,
    commentCount: 7234,
    featured: false,
    tags: ['狗仔', '女艺人', '富商', '密会'],
  },
  {
    id: 'article-8',
    slug: 'xuanxiu-jingli-baoliao',
    title: '前选秀选手爆料节目组黑幕：投票数据造假，出道位早已内定',
    excerpt: '一位曾参加某热门选秀节目的选手匿名爆料，称节目组的观众投票数据完全造假，出道名额在节目开播前就已经确定。',
    content: `一位自称参加了今年某热门选秀节目的选手通过匿名方式向本网爆料，揭露了选秀节目背后的惊人黑幕。据她透露，节目中所谓的"观众实时投票"完全是虚假的，所有投票数据都由节目组工作人员后台操控。

"在节目开播前，出道位就已经确定好了，哪些选手能走到最后都是提前安排好的。有些选手背后有大公司，公司会向节目组支付高额'推位费'，这些选手就能获得更多镜头和更好的剪辑。"这位选手透露道。

她还表示，有些实力派选手因为拒绝签署不平等的经纪合约，会被节目组恶意剪辑成"态度差""不合群"的形象，最终被淘汰出局。该爆料引发网友热议，不少参加过选秀的选手也纷纷发声，证实了类似情况的存在。`,
    cardImage: 'https://readdy.ai/api/search-image?query=Backstage%20of%20Chinese%20talent%20show%20competition%20dramatic%20spotlight%20on%20empty%20stage%20dark%20auditorium%20behind%20the%20scenes%20mood%20mysterious%20atmosphere%20editorial%20photography%20cinematic%20lighting%20high%20contrast&width=600&height=375&seq=card-xuanxiu-baoliao&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Backstage%20of%20Chinese%20talent%20show%20competition%20dramatic%20spotlight%20on%20empty%20stage%20dark%20auditorium%20behind%20the%20scenes%20mood%20mysterious%20atmosphere%20editorial%20photography%20cinematic%20lighting%20high%20contrast&width=1200&height=675&seq=detail-xuanxiu-baoliao&orientation=landscape',
    category: 'yule-shendu',
    author: '娱乐深扒君',
    publishDate: '2026-07-03',
    readCount: 276500,
    commentCount: 5342,
    featured: false,
    tags: ['选秀', '黑幕', '数据造假', '内定'],
  },
  {
    id: 'article-9',
    slug: 'remen-shijian-fanzhuan',
    title: '某热点事件出现惊天反转：爆料人承认造假，背后另有隐情',
    excerpt: '此前引发全网关注的某社会热点事件出现重大反转，最初爆料者公开承认部分信息系编造，背后可能涉及有组织的舆论操控。',
    content: `轰动一时的某热点事件在持续发酵一周后出现了惊人的反转。最初的爆料者在接受媒体采访时公开承认，其发布的所谓"内幕信息"中，有相当一部分是编造的，目的是为了"引起社会关注"。

更令人震惊的是，有证据表明该爆料并非个人行为，背后可能存在有组织的舆论操控。相关调查显示，事件发酵期间有大量水军账号参与传播扩散，且这些账号有组织、有分工，呈现出明显的网络营销特征。

此事引发了公众对网络信息真实性的广泛讨论。传媒学者指出，在热点事件中，公众应保持理性判断，不轻信未经证实的信息。"现在的网络环境是，真相还没穿上鞋，谣言已经跑遍了全世界。"`,
    cardImage: 'https://readdy.ai/api/search-image?query=Dramatic%20newspaper%20front%20page%20with%20reversal%20headline%20Chinese%20newsroom%20atmosphere%20scattered%20documents%20dramatic%20lighting%20sense%20of%20truth%20emerging%20editorial%20photography%20style%20cinematic%20mood%20high%20contrast%20warm%20and%20cool%20light%20mix&width=600&height=375&seq=card-shijian-fanzhuan&orientation=landscape',
    detailImage: 'https://readdy.ai/api/search-image?query=Dramatic%20newspaper%20front%20page%20with%20reversal%20headline%20Chinese%20newsroom%20atmosphere%20scattered%20documents%20dramatic%20lighting%20sense%20of%20truth%20emerging%20editorial%20photography%20style%20cinematic%20mood%20high%20contrast%20warm%20and%20cool%20light%20mix&width=1200&height=675&seq=detail-shijian-fanzhuan&orientation=landscape',
    category: 'shehui-redian',
    author: '爆料小分队',
    publishDate: '2026-07-02',
    readCount: 512300,
    commentCount: 10234,
    featured: false,
    tags: ['反转', '热点事件', '造假', '舆论操控'],
  },
];

export const featuredArticles = articles.filter(a => a.featured);
export const latestArticles = articles.sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime());
export const getArticlesByCategory = (slug: string) => articles.filter(a => a.category === slug);
export const getArticleBySlug = (slug: string) => articles.find(a => a.slug === slug);